declare global {
  interface Window {
    activeQuery: string[];
    typedQuery: string;
  }
}

import { filterResults, createQuery, removeFromArray } from './vacature-filters.helpers';
import { createIndex } from './vacature-filters.store';

window.activeQuery = [];
window.typedQuery = '';

function handleSearchEvent(index: any, vacatures: NodeListOf<HTMLDivElement>, event: Event) {
  // Get search query
  const { value } = event.target as HTMLInputElement;

  // Set the typed query
  window.typedQuery = value;

  // Search the index for query
  const results: Array<SearchResult> = createQuery(value, index);

  // Filter the vacatures
  filterResults(results, vacatures);
}

function handleTaxSort(
  button: HTMLButtonElement,
  index: any,
  vacatures: NodeListOf<HTMLDivElement>,
) {
  // If button is active,
  if (button.classList.contains('vacature-filters__button--active')) {
    // Remove active class
    button.classList.remove('vacature-filters__button--active');

    // Remove the search from array();
    removeFromArray(button.dataset.slug, window.activeQuery);

    // Create empty search
    const result = createQuery('', index);
    // Filter the vacatures
    filterResults(result, vacatures);

    // Exit the function
    return;
  }

  // Add active class to button
  button.classList.add('vacature-filters__button--active');

  // Set the query
  const query = button.dataset.slug;

  // Add query to active query
  window.activeQuery.push(query);

  // Search the index for query
  const results = createQuery(query, index);

  // Filter the vacatures
  filterResults(results, vacatures);
}

function addTaxSorter(index: any, vacatures: NodeListOf<HTMLDivElement>) {
  // Get all tax filter buttons
  const taxButtons = <NodeListOf<HTMLButtonElement>>(
    document.querySelectorAll('.vacature-filters__button')
  );

  // Add event listener to each button
  taxButtons.forEach((button) => {
    button.addEventListener('click', () => {
      handleTaxSort(button, index, vacatures);
    });
  });
}

/**
 * Load elasticlunr and initialize the index
 *
 * @returns {any} index
 */
async function initLunrSearch(searchField: HTMLInputElement) {
  const lunrModule = await import('elasticlunr');
  const elasticlunr = lunrModule.default;

  const index = createIndex(elasticlunr);
  const vacatures = <NodeListOf<HTMLDivElement>>document.querySelectorAll('.vacature-card');

  addTaxSorter(index, vacatures);

  searchField.addEventListener('keyup', handleSearchEvent.bind(null, index, vacatures));
}

// Initialize search
const searchField = <HTMLInputElement>document.getElementById('vacature-filter-and-search--search');
if (searchField) {
  initLunrSearch(searchField);
}
